import React, { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { X } from "lucide-react";
import api from "@/lib/api";

const pk = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = pk ? loadStripe(pk) : null;

export const CheckoutDialog = ({ payload, onClose }) => {
  const fetchClientSecret = useCallback(async () => {
    const { data } = await api.post("/payments/checkout", { ...payload, embedded: true });
    return data.client_secret;
  }, [payload]);

  return (
    <div data-testid="checkout-dialog" className="fixed inset-0 z-[80] flex items-start justify-center overflow-y-auto bg-black/60 backdrop-blur-sm p-4 sm:p-8" onClick={onClose}>
      <div className="relative w-full max-w-xl bg-white rounded-3xl shadow-2xl mt-6 mb-10" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-black/10">
          <span className="font-serif text-xl text-neutral-900">Complete your reservation</span>
          <button data-testid="checkout-close" onClick={onClose} className="rounded-full p-1.5 hover:bg-black/5 transition-colors"><X size={20} className="text-neutral-700" /></button>
        </div>
        <div className="p-2 sm:p-4">
          {!stripePromise ? (
            <p data-testid="checkout-no-key" className="text-center text-neutral-500 text-sm p-8">Payments are being set up. Please check back shortly.</p>
          ) : (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckoutDialog;
